<template>

    <div class="cards">

        <div class="cards__container"
            v-if="subscriptions.length > 0"
>

            <div class="cards__stack">

                <joker :card="nextNextCard"
                       :style="nextNextCardStyle"
                       :key="nextNextCard.name"
                       v-if="nextNextCard"
                       class="cards__next__next"
                ></joker>

                <joker :card="nextCard"
                       :style="nextCardStyle"
                       v-if="nextCard"
                       :key="nextCard.name"
                       class="cards__next"
                ></joker>

                <vue-swing class="cards__swing"
                           ref="vueSwing"
                           v-if="showSwing"
                           @throwoutup="action(ENUM.NEWSLETTERS.ACTIONS.DELETE)"
                           @throwoutleft="action(ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES)"
                           @throwoutright="action(ENUM.NEWSLETTERS.ACTIONS.KEEP)"
                           @dragstart="dragstart"
                           @dragmove="dragmove"
                           @dragend="dragend"
                           :config="config">

                    <joker ref="elementSwing"
                           v-if="actualCard"
                           class="cards__card"
                           :card="actualCard"
                           :key="actualCard.name"
                           @share="$emit('share')"
                    ></joker>

                </vue-swing>
            </div>

        </div>

        <empty-spoum-area :subscriptions="subscriptions" :category="category"></empty-spoum-area>

        <actions-bar @action="action"  v-show="showActionBar"></actions-bar>

        <animation-cta-card></animation-cta-card>

    </div>

</template>

<script>
import VueSwing from 'vue-swing'
import Vuex from 'vuex'

import ENUM from '../../assets/ENUM'

import Tag from '../../modules/tag'

import ActionsBar from '../../components/newsletters-v2/ActionsBar'
import AnimationCtaCard from '../../components/newsletters-v2/AnimationCtaCard'
import EmptySpoumArea from '../../components/newsletters-v2/EmptySpoumArea'
import Joker from '../../components/newsletters-v2/cardsTemplate/Joker'

export default {

    name: 'cards',

    components: {
        ActionsBar,
        AnimationCtaCard,
        EmptySpoumArea,
        VueSwing,
        Joker
    },

    props: {
        subscriptions: {
            type: Array,
            default: () => []
        },

        category: {
            type: String,
            default: ''
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'isCardDraging'
            ]),

        ENUM() {
            return ENUM
        },

        actualCard() {
            return this.subscriptions[0]
        },

        nextCard() {
            return this.subscriptions[1]
        },

        nextNextCard() {
            return this.subscriptions[2]
        },

        nextCardStyle() {
            return `width: ${this.cardWidth - 16}px;`
        },

        nextNextCardStyle() {
            return `width: ${this.cardWidth - 32}px;`
        },

        showActionBar() {
            return this.subscriptions.length > 0 && !this.isCardDraging
        },

        showAnimationCtaCard() {
            return this.isCardDraging
        }
    },

    data() {

        return {
            config: {
                throwOutConfidence: (xOffset, yOffset, element) => {
                    if (Math.abs(xOffset) > yOffset) {

                        const xConfidence = Math.min(Math.abs(xOffset) / element.offsetWidth, 1)
                        const yConfidence = Math.min(Math.abs(yOffset) / element.offsetHeight, 1)
                        const result = Math.max(xConfidence, yConfidence)
                        return result > 0.5 ? 1 : result
                    }
                    return 0
                },
                allowedDirections: [VueSwing.Direction.RIGHT, VueSwing.Direction.UP, VueSwing.Direction.LEFT]
            },
            cardWidth: 0,
            cardHeight: 0,
            showSwing: true
        }
    },

    mounted() {

        window.addEventListener('keydown', this.keydown)
        window.addEventListener('resize', this.resizeHandler)
        this.resizeHandler()
    },

    methods: {


        ...Vuex.mapActions([
            'updateCardDragDirection',
            'updateCardDraging'
        ]),

        action(enumAction) {
            switch (enumAction) {
                case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                    Tag.clickAll(this, 'delete_swipe')
                    break
                case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                    Tag.clickAll(this, 'unsub_swipe')
                    break
                case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                    Tag.clickAll(this, 'keep_swipe')
                    break
            }
            this.$emit('action', {enumAction, senders: [this.actualCard]})
        },

        dragstart() {
            this.updateCardDraging(true)
        },

        dragend() {
            this.updateCardDraging(false)
        },

        dragmove(event) {
            switch (event.throwDirection) {
                case VueSwing.Direction.UP:
                    this.updateCardDragDirection(ENUM.DIRECTIONS.UP)
                    break
                case VueSwing.Direction.RIGHT:
                    this.updateCardDragDirection(ENUM.DIRECTIONS.RIGHT)
                    break
                case VueSwing.Direction.LEFT:
                    this.updateCardDragDirection(ENUM.DIRECTIONS.LEFT)
                    break
                default:
                    this.updateCardDragDirection('')

            }
        },


        btnAction(enumAction) {

            switch (enumAction) {
                case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                    Tag.clickAll(this, 'autodelete')
                    break
                case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                    Tag.clickAll(this, 'delete')
                    break
                case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                    Tag.clickAll(this, 'keep')
                    break
            }

            this.action(enumAction)
        },

        keydown(event) {
            switch (event.keyCode) {
                case 37:
                    this.action(ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES)
                    break
                case 38:
                    this.action(ENUM.NEWSLETTERS.ACTIONS.DELETE)
                    break
                case 39:
                    this.action(ENUM.NEWSLETTERS.ACTIONS.KEEP)
                    break
            }
        },

        resizeHandler() {
            if (this.$refs.vueSwing) {
                this.cardWidth = this.$refs.vueSwing.$el.clientWidth
                this.cardHeight = this.$refs.vueSwing.$el.clientHeight
            }
        },

        refresh() {
            // refresh when rollback after throw out.
            // Need setTimeOut for Break Vue state and change the value of "showSwing"
            this.showSwing = false

            setTimeout(() => {
                this.showSwing = true
            }, 10)

        }
    },

    destroyed() {
        window.removeEventListener('keydown', this.keydown)
        window.removeEventListener('resize', this.resizeHandler)
    }
}

</script>

<style lang="scss" scoped>

.cards {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 40px 16px 16px;
    background-color: $cultured;
    position: relative;

    &__container {
        display: flex;
        flex-grow: 1;
        justify-content: center;

        @media screen and (min-width: $above-tablet-length) {
            align-items: center;
            flex-direction: column;
        }
    }

    &__stack {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        max-width: 480px;
        position: relative;
        max-height: 326px;
        flex-grow: 1;
    }

    &__swing {
        width: 100%;
        max-width: 440px;
        max-height: 358px;
        display: flex;
        flex-grow: 1;
        cursor: pointer;
    }

    &__card {
        z-index: 1;
    }

    &__next {
        position: absolute;
        top: -8px;
        left: 8px;
        right: 8px;
        bottom: 8px;
        background-color: $white;

        &__next {
            position: absolute;
            top: -16px;
            left: 16px;
            right: 16px;
            bottom: 16px;
            background-color: $white;
        }
    }
}

</style>
